'use client'

import { DM_Sans } from 'next/font/google'
import FaqFooter from '@/components/marketing/FaqFooter'
import WhitelabelCTA from '@/components/services/WhitelabelCTA'
import SmartAIWidgets from '@/components/ai/SmartAIWidgets'
import aiFaqs from '@/data/ai-faqs.json'

const dmSans = DM_Sans({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
})

export default function SmartAIPage() {
  return (
    <div className={`smart-ai ${dmSans.className}`}>
      <SmartAIWidgets />

      <WhitelabelCTA
        formSource="smart-ai-lp"
        serviceName="SmartAgents"
        focusAreaPlaceholder="Lead response is slow. Calls aren't landing in the CRM. Want an agent on first reply."
      />

      <FaqFooter
        title={
          <>
           Questions clients
           ask first.
          </>
        }
        faqs={aiFaqs}
      />
    </div>
  )
}
